import { useStyledToast } from './general.hooks';

export function useLoginShared() {
  const toast = useStyledToast();

  const openErrorToast = (msg, description) =>
    toast({
      title: msg,
      description,
      status: 'error',
      isClosable: true,
      duration: 4000
    });

  const openCredsErrorToast = (e) =>
    openErrorToast('Invalid Login Attempt', (e?.response?.data?.errors ?? []).join(', '));

  const openOTPSuccessToast = () => {
    toast({
      title: 'Login Link Sent',
      description: 'If your email is registered, you will receive a login link shortly.',
      status: 'success',
      isClosable: true,
      duration: 4000
    });
  };

  const openOTPErrorToast = (msg) => {
    toast({
      title: 'Error Sending Login Link',
      description: msg,
      status: 'error',
      isClosable: true,
      duration: 4000
    });
  };

  return { openErrorToast, openCredsErrorToast, openOTPSuccessToast, openOTPErrorToast };
}
